import React from 'react';
import { Card, CardContent } from '@material-ui/core';
import ColorBlendSpinner from './ColorBlendSpinner';

export default function SpinnerCard() {
  return (
    <Card>
      <CardContent>
        <ColorBlendSpinner />
      </CardContent>
    </Card>
  );
}
